import ReportTable from './ReportTable';

export default ReportTable
